import { useAuth } from '../../context/auth';
import styles from './forbiddenFallback.module.css';

export interface ForbiddenFallbackProps {
  requiredGroups?: string[];
}

export function ForbiddenFallback({ requiredGroups }: ForbiddenFallbackProps) {
  const { user, forbiddenUserInfo } = useAuth();

  const displayName = user?.name ?? forbiddenUserInfo?.login;
  const displayEmail = user?.email ?? forbiddenUserInfo?.email;

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <h1>Leider haben Sie keinen Zugriff</h1>
        {displayName && (
          <p className={styles['userInfo']}>
            <strong>{displayName}</strong>
            {displayEmail && <> ({displayEmail})</>}
          </p>
        )}
        <p>Sie haben keine Berechtigung, auf diese Anwendung zuzugreifen.</p>
        {requiredGroups && requiredGroups.length > 0 && (
          <div className={styles['groups']}>
            <p>
              Um Zugriff zu erhalten, muss Ihr Konto einer der folgenden
              SharePoint-Gruppen zugeordnet sein:
            </p>
            <ul>
              {requiredGroups.map((group) => (
                <li key={group}>{group}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
